// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_closes_at = /** @type {(inputs: { time: NonNullable<unknown> }) => string} */ (i) => {
	return `We close at ${i.time}`
};

const el_closes_at = /** @type {(inputs: { time: NonNullable<unknown> }) => string} */ (i) => {
	return `Κλείνουμε στις ${i.time}`
};

const ru_closes_at = /** @type {(inputs: { time: NonNullable<unknown> }) => string} */ (i) => {
	return `Закрываемся в ${i.time}`
};

const he_closes_at = /** @type {(inputs: { time: NonNullable<unknown> }) => string} */ (i) => {
	return `נסגר ב-${i.time}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ time: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const closes_at = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.closes_at(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("closes_at", locale)
	if (locale === "en") return en_closes_at(inputs)
	if (locale === "el") return el_closes_at(inputs)
	if (locale === "ru") return ru_closes_at(inputs)
	if (locale === "he") return he_closes_at(inputs)
	return "closes_at"
};